export default "__VITE_ASSET__Dv0vvoWT__"